<template>
  <div>
    

    <!-- <input v-model="ticker" placeholder="AAPL"> -->
    <div v-if="series.length">

      <h1 align="center">Price Chart</h1>

      <div class="inputbox">
        <select v-model="period" class="selectbox">
          <option disabled value="">Please select one</option>
          <option>1 day</option>
          <option>1 month</option>
          <option>1 year</option>
        </select>

        <select v-model="interval" class="selectbox">
          <option disabled value="">Please select one</option>
          <option>1 minute</option>
          <option>5 minute</option>
          <option>1 day</option>
        </select>

        <button v-on:click="fetchData" class="updatebutton">Update</button>
      </div>


      <div id="chart" class=card v-bind:class="{'card greenCard': makeGreen, 'card redCard': !makeGreen}">
        <apexchart type=candlestick align=center :options="chartOptions" :series="series"></apexchart>
      </div>

    </div>

  </div>
</template>
<script>
import axios from 'axios';
import VueApexCharts from 'vue-apexcharts';


export default {
  name: 'PriceChart',
  components:{
    'apexchart': VueApexCharts,
  },
  props:['ticker'],
  data() {
    return {
        // ticker: 'AAPL',
        period: '1y',
        interval: '1d',
        // ticker: null,
        // period: null,
        // interval: null,
        data: null,
        series: [],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            }
          },
          xaxis: {
            type: 'datetime'
          },
          yaxis: {
            tooltip: {
              enabled: true
            },
            labels: {
              formatter: function (value) {
                return value.toFixed(2);
              }
            }
          }
        },
    }
  },
  // computed: {},
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let params = {
        'ticker':this.ticker,
        'period':this.period,
        'interval':this.interval,
      }
      await axios
        .get(`${process.env.VUE_APP_DATA_API_HOST}/history`, {params:params})
        .then(response => {
          this.data = response.data
          this.createSeries()
          this.updateColors(response.data)
        })
        .catch(e => {
          e
        })
    },
    createSeries() {
      let data = this.data['data']
      let newData = []
      for (var key in data){
        if (Object.prototype.hasOwnProperty.call(data,key)) {
          newData.push({'x':new Date(key),'y':[data[key]['Open'],data[key]['High'],data[key]['Low'],data[key]['Close']]})
        }
      }
      this.series = [{'data':newData}]
    },
    updateColors(data_in) {
      let data = data_in["data"];
      let keys = Object.keys(data);
      let last = data[keys[keys.length-1]]["Close"]
      let first = data[keys[0]]["Close"]
      this.makeGreen = last > first ? true : false;
    }
  },
  watch:{
    ticker: function () {
      this.fetchData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.inputbox{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.selectbox{
  border:1px solid #BBBBBB;
  border-radius: 5px;
  border-color:#BBBBBB;
  /* height:100%; */
}
.updatebutton{
  border:1px solid #BBBBBB;
  border-radius: 5px;
  border-color:#BBBBBB;
  /* height:100%; */
}

.card {
    /* Add shadows to create the "card" effect */
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
      transition: 0.3s;
      border-radius: 10px;
    }

.card.greenCard {
      background-color: rgba(186, 228, 186, 0.1) !important;
      
  }

  .card.redCard {
    background-color: rgba(228, 187, 186, 0.1) !important;
    
  }
</style>